// extracted by mini-css-extract-plugin
export default {"myBtn":"btn_myBtn__717dR","cancel":"btn_cancel__p8yuU"};